module.exports = __webpack_public_path__ + "img/category-reagent.120cbba4.svg";